var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-sheet', {
    attrs: {
      "height": "64"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center",
      "no-gutters": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _c('v-toolbar-title', {
    staticClass: "mx-4"
  }, [_vm._v(_vm._s(_vm.tituloMes))]), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.next
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1), _c('v-sheet', [_c('v-calendar', {
    ref: "calendar",
    attrs: {
      "color": "primary",
      "events": _vm.eventos,
      "event-color": _vm.getEventColor,
      "type": "month",
      "show-adjacent-months": "false",
      "show-event-overlap": _vm.mostrarTodosEventos,
      "event-more": true
    },
    on: {
      "click:event": _vm.confirmarRemocao,
      "change": _vm.emitirRange
    },
    scopedSlots: _vm._u([{
      key: "more",
      fn: function (_ref) {
        var events = _ref.events;
        return [_c('div', {
          staticClass: "more-link",
          on: {
            "click": function ($event) {
              _vm.mostrarTodosEventos = true;
            }
          }
        }, [_vm._v(" Mais " + _vm._s(events.length) + " ")])];
      }
    }]),
    model: {
      value: _vm.focus,
      callback: function ($$v) {
        _vm.focus = $$v;
      },
      expression: "focus"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }